var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('h1',[_vm._v(_vm._s(_vm.$t('tag-manager')))])]),_c('div',{staticClass:"col-md-3"},[_c('router-link',{staticClass:"btn btn-primary btn-block btn-lg mb-3",attrs:{"to":"/settings/tag"}},[_vm._v(" "+_vm._s(_vm.$t('new-tag'))+" ")])],1)]),_c('Table',{attrs:{"loading":_vm.loading,"submitting":_vm.submitting,"cols":[
                { key: 'name', heading: _vm.$t('name'), size: 6 },
                { key: 'taggroup_id', heading: _vm.$t('tag-group-name'), size: 6,
                    cb: function (tag) {
                        var match = _vm.taggroups.find(function (obj) { return obj.id == tag.taggroup_id; });
                        if(match){
                            var name = match.name;
                            return name
                        } else {
                            return ;
                        }

                    }
                }
            ],"data":_vm.tags,"breakpoint":"md","filters":Object.assign({}, _vm.filters,
                {page: _vm.filters.page,
                page_size: _vm.filters.page_size}),"searchable":true,"scrollPaginate":true},on:{"refresh":_vm.refresh,"selectItem":function (tag) { return _vm.$router.push(("/settings/tag/" + (tag.id))); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }